<div class="min-h-screen w-full flex flex-col bg-white" >
  
  <div class="relative w-full">
    <!-- Background Image -->
    <img 
      [src]="tenant.getImg(tenant.GIVEAWAYS)" 
      alt="Hero Background"
      class="w-full h-[420px] object-cover">

    <!-- Text Content -->
    <div class="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-4">
      <h1 class="md:text-6xl text-5xl text-white font-extrabold mb-2">Win an unforgettable <br> game day experience </h1>
      <p class="md:text-3xl  font-semibold mt-4">
        Enter by {{this.loadeddata?.GiveawayEventEndDate}} for your shot at an exclusive <br> {{this.loadeddata?.GiveawayEventDate}}!
      </p>
    </div>
  </div>

	<div class="text-white py-6 px-4" [style.backgroundColor]="loadeddata?.PrimaryColor">
		<h2 class="text-center font-semibold mb-6 text-white">PREMIUM GIVEAWAYS INCLUDES:</h2>

		<div class="grid grid-cols-4 md:grid-cols-4 gap-6 text-center md:max-w-[50%] mx-auto">
			<div *ngFor="let item of iconsWithLabels">
				<img [src]="item.icon" [alt]="item.label" class="mx-auto h-10 md:h-12 mb-2">
				<p class="text-xs md:text-sm">{{ item.label }}</p>
			</div>
		</div>
	</div>

<div class="my-16 flex items-center justify-center">
  <div class="md:max-w-2xl w-full px-6">
    <h3 class="text-3xl font-bold text-center mb-6">
      Fill in your info for a chance to win.
    </h3>

    <form #giveawayForm="ngForm" (ngSubmit)="submitForm(giveawayForm)">
  <!-- Name -->
  <input
    type="text"
    placeholder="Enter your Name"
    [(ngModel)]="formData.name"
    name="name"
	maxlength="256"
    required
    class="w-full rounded-lg px-4 py-3 placeholder-gray-500 focus:ring-2 focus:ring-[{{this.loadeddata.PrimaryColor}}] focus:outline-none outline-none border-transparent">
  <div *ngIf="giveawayForm.submitted && !formData.name" class="text-red-500 text-sm pb-2 block mt-1 font-semibold">
    Name is required.
  </div>

  <!-- Email -->
  <input
    type="email"
	pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
    placeholder="Enter your Email Address"
    [(ngModel)]="formData.email"
    name="email"
    required
    maxlength="256"
    #emailCtrl="ngModel"
    class="w-full mt-4 rounded-lg px-4 placeholder-gray-500 py-3 focus:ring-2 focus:ring-[{{this.loadeddata.PrimaryColor}}] focus:outline-none outline-none border-transparent">
  <div *ngIf="giveawayForm.submitted && emailCtrl.invalid" class="text-red-500 text-sm mt-1 font-semibold">
    A valid email address is required.
  </div>

  <!-- State -->
	<select [(ngModel)]="formData.state"
			name="state"
			required
			#stateCtrl="ngModel"
			class="w-full text-black mt-4 bg-white border border-[#ccc] rounded-lg px-4 py-3 focus:ring-2 focus:ring-[{{this.loadeddata.PrimaryColor}}] focus:outline-none outline-none">
		<option value="">Select your State</option>
		<option value="AL">Alabama</option>
		<option value="AK">Alaska</option>
		<option value="AZ">Arizona</option>
		<option value="AR">Arkansas</option>
		<option value="CA">California</option>
		<option value="CO">Colorado</option>
		<option value="CT">Connecticut</option>
		<option value="DE">Delaware</option>
		<option value="DC">District Of Columbia</option>
		<option value="FL">Florida</option>
		<option value="GA">Georgia</option>
		<option value="HI">Hawaii</option>
		<option value="ID">Idaho</option>
		<option value="IL">Illinois</option>
		<option value="IN">Indiana</option>
		<option value="IA">Iowa</option>
		<option value="KS">Kansas</option>
		<option value="KY">Kentucky</option>
		<option value="LA">Louisiana</option>
		<option value="ME">Maine</option>
		<option value="MD">Maryland</option>
		<option value="MA">Massachusetts</option>
		<option value="MI">Michigan</option>
		<option value="MN">Minnesota</option>
		<option value="MS">Mississippi</option>
		<option value="MO">Missouri</option>
		<option value="MT">Montana</option>
		<option value="NE">Nebraska</option>
		<option value="NV">Nevada</option>
		<option value="NH">New Hampshire</option>
		<option value="NJ">New Jersey</option>
		<option value="NM">New Mexico</option>
		<option value="NY">New York</option>
		<option value="NC">North Carolina</option>
		<option value="ND">North Dakota</option>
		<option value="OH">Ohio</option>
		<option value="OK">Oklahoma</option>
		<option value="OR">Oregon</option>
		<option value="PA">Pennsylvania</option>
		<option value="RI">Rhode Island</option>
		<option value="SC">South Carolina</option>
		<option value="SD">South Dakota</option>
		<option value="TN">Tennessee</option>
		<option value="TX">Texas</option>
		<option value="UT">Utah</option>
		<option value="VT">Vermont</option>
		<option value="VA">Virginia</option>
		<option value="WA">Washington</option>
		<option value="WV">West Virginia</option>
		<option value="WI">Wisconsin</option>
		<option value="WY">Wyoming</option>
	</select>
	<div *ngIf="giveawayForm.submitted && stateCtrl.invalid" class="text-red-500 text-sm mt-1 font-semibold">
		State selection is required.
	</div>

  <!-- Phone -->
  <input
	required
    type="tel"
    placeholder="Enter your Phone Number"
	(keypress)="this.filterPhone($event)"
    [(ngModel)]="formData.phone"
    name="phone"
    pattern="[0-9]{10,15}"
	minlength="10"
    maxlength="15"
    #phoneCtrl="ngModel"
    class="mt-4 w-full rounded-lg px-4 placeholder-gray-500 py-3 focus:ring-2 focus:ring-[{{this.loadeddata.PrimaryColor}}] focus:outline-none  outline-none border-transparent">
  <div *ngIf="giveawayForm.submitted && phoneCtrl.invalid" class="text-red-500 text-sm mt-1 font-semibold">
    Phone number is requried, must contain at least ten digits, and can only contain digits (0-9).
  </div>

   <div class="flex items-start mt-4">
    <input
      id="agree"
      type="checkbox"
      [(ngModel)]="formData.agree"
      name="agree"
      required
	  #termsCtrl="ngModel"
      class="checkbox accent-blue-500">
    <label for="agree" class="text-black ml-2 text-sm cursor-pointer">
      I agree to the
     <a target="_blank" href="{{this.giveawayTermsUrl}}" class="underline" [ngStyle]="{color:this.loadeddata.PrimaryColor}">Terms & Conditions</a>
      governing this promotion.
    </label>
  </div>
	<div *ngIf="giveawayForm.submitted && termsCtrl.invalid" class="text-red-500 text-sm mt-1 font-semibold">
		You must agree to the Terms & Conditions to continue.
	</div>

  <button [style.backgroundColor]="loadeddata?.PrimaryColor" type="submit" class="w-full mt-4 text-white font-bold p-3 rounded-lg transition">
    Enter for a Chance to Win!
  </button>

  <p class="text-xs text-gray-600 mt-4">
    <strong>* Why We Ask for Your Phone Number:</strong><br />
    We'll only use your phone number to contact you if you're selected as a winner and to give
    you details on how to redeem your prize. We will not sell, rent, or share your phone number.
  </p>
</form>

  </div>
</div>
  
</div>

